<template>
  <div class="cmp-checkBox">
    <label>{{ label }}</label>
    <p :class="{ bg: value.code === item.code }" @click="change(item)" v-for="(item, index) in data" :key="index">
      {{ item.value }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["value", "label", "data"],
  // props: {
  //   value: {
  //     type: String,
  //     default: () => {
  //       return "";
  //     },
  //   },
  //   label: {
  //     type: String,
  //     default: () => {
  //       return "";
  //     },
  //   },
  //   data: {
  //     type: Array,
  //     default: () => {
  //       return [];
  //     },
  //   },
  // },
  methods: {
    change(item) {
      this.$emit("input", item);
      this.$emit("change");
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/styles/public.less";

.cmp-checkBox {
  font-size: 14px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #657180;
  display: flex;
  .flex_align_items;
  > label {
    font-size: 16px;
    font-family: SourceHanSansCN-Light, SourceHanSansCN;
    font-weight: 300;
    color: #333333;
  }
  .bg {
    background: #19a4ff;
    color: #fff;
  }
  p {
    min-width: 76px;
    height: 28px;
    border-radius: 6px;
    padding: 0 7px;
    .flex_center;
    margin: 0 15px;
    &:hover {
      color: #fff;
      background: #19a4ff;
      cursor: pointer;
    }
  }
}
</style>
